export default __webpack_public_path__ + "static/media/avatar8.9719f145.png";